import SpinCustom from '@/components/ui/ui-react-antd/SpinCustom'

import React, { lazy } from 'react'
import { type RouteObject, createBrowserRouter } from 'react-router-dom'
import ROUTER from '../ROUTER'
import { adminRoutes } from './components/adminRoutes'
import { publicRoutes } from './components/publicRoutes'
import { userRoutes } from './components/userRoutes'

// common
const PublicRouters = React.lazy(() => import('@/pages/SUPPORTPAGES/PublicRouters'))
const PrivateRoutes = React.lazy(() => import('@/pages/SUPPORTPAGES/PrivateRoutes'))

const SvgViewer = React.lazy(() => import('@/pages/SUPPORTPAGES/SvgViewer'))
const DeveloperSyncData = React.lazy(() => import('@/features/developer-sync-data'))
const NotFound = React.lazy(() => import('@/pages/SUPPORTPAGES/NotFound/404'))
const Home = lazy(() => import('@/pages/ANONYMOUS/Home'))
// USER
// const MyAccount = lazy(() => import('@/pages/USER/MyAccount'))

// Ideally this would be an API call to server to get logged in user data
// const getUserData = () => {};

export function LazyLoadingComponent({ ...rest }) {
  return (
    <React.Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          <SpinCustom />
        </div>
      }
    >
      {rest.children}
    </React.Suspense>
  )
}
const routes: RouteObject[] = [
  {
    path: ROUTER.SVG_VIEWER,
    element: (
      <LazyLoadingComponent>
        <SvgViewer />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.DEVELOPER_SYNC_DATA,
    element: (
      <LazyLoadingComponent>
        <DeveloperSyncData />
      </LazyLoadingComponent>
    ),
  },
  // ADMIN
  ...adminRoutes,
  //  USER
  {
    element: (
      <LazyLoadingComponent>
        <PrivateRoutes />
      </LazyLoadingComponent>
    ),
    children: [...userRoutes],
  },
  //  ANONYMOUS
  {
    element: (
      <LazyLoadingComponent>
        <PublicRouters />
      </LazyLoadingComponent>
    ),
    //  loader: () => defer({ userPromise: getUserData() }),
    children: [
      ...publicRoutes,
      {
        index: true,
        path: ROUTER.HOME,
        element: (
          <LazyLoadingComponent>
            <Home />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  {
    path: '*',
    element: (
      <LazyLoadingComponent>
        <NotFound />
      </LazyLoadingComponent>
    ),
  },
]

export const router = createBrowserRouter(routes)
